import { render, staticRenderFns } from "./RepairInfo.vue?vue&type=template&id=493eaddf&scoped=true"
import script from "./RepairInfo.vue?vue&type=script&lang=js"
export * from "./RepairInfo.vue?vue&type=script&lang=js"
import style0 from "./RepairInfo.vue?vue&type=style&index=0&id=493eaddf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493eaddf",
  null
  
)

export default component.exports